<template>
  <div class="whatsapp-management">
    <ProGate feature="la gestion WhatsApp" />
    <!-- Notification component -->
    <transition name="fade">
      <div v-if="notification.show" 
           class="notification" 
           :class="notification.type">
        <div class="notification-content">
          <svg v-if="notification.type === 'success'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
          <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 8v4M12 16h.01"/>
          </svg>
          <span>{{ notification.message }}</span>
        </div>
      </div>
    </transition>

    <PageHeader 
      pageName="WhatsApp" 
      pageTitle="Comptes WhatsApp" 
      pageSubtitle="Gérez vos comptes WhatsApp Business et leurs associations avec vos agents IA."
    >
      <template #actions>
        <button class="sleek-add-btn" @click="showAddModal = true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 5v14M5 12h14"/>
          </svg>
          <span>Associer un compte</span>
        </button>
      </template>
    </PageHeader>

    <!-- Notification de paiement -->
    <div v-if="showPaymentNotice" class="payment-notification">
        <div class="payment-notification-content">
          <div class="payment-notification-header">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 8v4M12 16h.01"/>
            </svg>
            <span>Ajoutez un moyen de paiement à votre compte WhatsApp Business</span>
            <button class="close-payment-notice" @click="showPaymentNotice = false">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="payment-notification-body" :class="{ 'expanded': showMorePaymentDetails }">
            <p>Pour pouvoir utiliser pleinement notre service (envoi et réception de messages via notre application), vous devez ajouter un moyen de paiement à votre compte Business Meta.</p>
            <a href="https://www.facebook.com/business/help/488291839463771" target="_blank" rel="noopener noreferrer" class="payment-help-link">
              https://www.facebook.com/business/help/488291839463771
            </a>
            <div v-if="showMorePaymentDetails" class="payment-more-details">
              <p>Voici comment faire :</p>
              <ol>
                <li>Rendez-vous sur le Gestionnaire WhatsApp via ce lien : <a href="https://business.facebook.com/wa/manage/home/" target="_blank" rel="noopener noreferrer">https://business.facebook.com/wa/manage/home/</a></li>
                <li>Cliquez sur le bouton « Ajouter un moyen de paiement » dans le panneau Vue d'ensemble</li>
                <li>Suivez les étapes pour compléter l'ajout du moyen de paiement</li>
              </ol>
              <p>Une fois cette étape complétée, votre compte sera entièrement intégré à la plateforme WhatsApp Business, et nous pourrons activer votre accès à notre application.</p>
              <p>N'hésitez pas à nous contacter si vous avez besoin d'assistance.</p>
            </div>
            <button class="voir-plus-btn" @click="showMorePaymentDetails = !showMorePaymentDetails">
              {{ showMorePaymentDetails ? 'Voir moins' : 'Voir plus' }}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" :class="{ 'rotated': showMorePaymentDetails }">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
          </div>
        </div>
      </div>


     <!-- Liste des comptes -->
    <div v-if="loading" class="loading-state">
      <div class="loading-spinner">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-dashoffset="60">
            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
          </circle>
        </svg>
      </div>
      <p>Chargement des comptes WhatsApp...</p>
    </div>
    
    <div v-else-if="error" class="error-state">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8v4M12 16h.01"/>
      </svg>
      <p>{{ error }}</p>
      <button class="retry-btn" @click="fetchAccounts">
        Réessayer
      </button>
    </div>
    
    <div v-else>
      <div class="accounts-grid">
         
        <div v-for="account in accounts" :key="account._id" class="account-card">
         
          <div class="account-header">
            <div class="account-icon">
              <svg fill="currentColor" width="24" height="24" viewBox="0 0 506.964 506.964">
                <g transform="translate(2 1)">
                  <g>
                    <g>
                      <path d="M252.321-1C113.83-1,1.357,111.472,1.357,249.125c0,43.646,11.751,85.613,33.574,124.223L-2,505.964l135.134-36.092
                        c39.449,20.984,80.577,32.734,119.187,32.734c136.813,0,252.643-115.83,252.643-253.482S391.652-1,252.321-1z M252.321,485.82
                        c-36.931,0-76.38-11.751-114.151-32.734l-3.357-1.679L21.502,482.462L52.557,370.83l-1.679-3.357
                        c-20.984-36.092-32.734-77.22-32.734-118.348c0-128.42,104.918-233.338,234.177-233.338
                        c130.098,0,235.856,104.918,235.856,233.338S379.902,485.82,252.321,485.82z"/>
                      <path d="M252.321,40.967c-114.99,0-208.997,93.167-208.997,208.157c0,41.128,11.751,79.738,32.734,114.151l3.357,4.197
                        L56.754,447.21l82.256-20.984l4.197,2.518c34.413,20.984,72.184,31.895,109.115,31.895c115.83,0,210.675-94.846,210.675-211.515
                        C462.997,134.134,368.151,40.967,252.321,40.967z M251.482,444.692c-33.574,0-67.987-10.911-99.882-30.216l-10.072-6.715
                        l-61.272,15.108l16.787-58.754l-6.715-10.911c-20.144-31.056-30.216-67.148-30.216-104.079
                        c0-104.918,86.452-191.37,192.21-191.37c106.597,0,193.889,86.452,193.889,191.37
                        C446.21,356.561,358.918,443.852,251.482,444.692z"/>
                      <path d="M378.223,295.289l-52.879-24.341c-7.554-3.357-15.108-0.839-20.144,5.036l-20.144,26.02
                        c-15.108-5.875-57.075-24.341-81.416-69.666l18.466-21.823c4.197-5.036,5.036-11.751,2.518-17.626l-22.662-53.718
                        c-2.518-5.875-7.554-10.072-14.269-10.072l-15.948-0.839c-6.715,0-14.269,1.679-19.305,6.715
                        c-7.554,6.715-21.823,20.984-26.02,40.289c-5.875,27.698,3.357,60.433,26.859,92.328
                        c14.269,20.144,57.915,79.738,141.849,103.239c8.393,2.518,16.787,3.357,24.341,3.357c14.269,0,27.698-4.197,39.449-10.911
                        c13.43-8.393,22.662-22.662,26.02-37.771l2.518-11.751C389.134,306.2,384.938,298.646,378.223,295.289z M367.311,321.308
                        c-2.518,10.911-9.233,20.984-18.466,26.859c-14.269,9.233-31.056,10.911-49.521,5.875
                        c-78.059-21.823-119.187-78.059-132.616-96.525c-20.144-27.698-28.538-56.236-23.502-78.898
                        c3.357-15.108,14.269-26.02,20.984-31.895c1.679-1.679,4.197-2.518,6.715-2.518l16.787,1.679l22.662,52.879l-20.144,22.662
                        c-3.357,4.197-4.197,10.911-1.679,15.948c27.698,53.718,78.059,74.702,93.167,79.738c5.875,1.679,11.751,0,15.948-5.036
                        l20.144-26.859l52.879,24.341L367.311,321.308z"/>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="account-info">
              <div class="account-info-header">
                <h3>{{ account.verified_name }}</h3>
                <div class="status-icon" :class="{ 'active': account.code_verification_status === 'VERIFIED' || account.code_verification_status === 'EXPIRED', 'inactive': account.code_verification_status === 'NOT_VERIFIED' }">
                  <svg v-if="account.code_verification_status === 'VERIFIED' || account.code_verification_status === 'EXPIRED'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 1 0 0-20z"/>
                    <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 1 0 0-20z"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" fill="none"/>
                  </svg>
                </div>
              </div>
              <div class="account-subinfo">
                <p class="phone-number clickable-text" @click.stop="copyToClipboard(account.display_phone_number, 'Numéro')" title="Copier le numéro">
                  {{ account.display_phone_number }}
                </p>
                <p v-if="account.idbot" class="bot-id clickable-text" @click.stop="copyToClipboard(account.idbot, 'ID Bot')" title="Copier l'ID">
                  ID: {{ account.idbot }}
                </p>
                <p class="account-type">{{ account.type === 'ecommerce' ? 'E-commerce' : 'Service client' }}</p>
              </div>
              <p class="verification-status" :class="{ 'not-verified': account.code_verification_status === 'NOT_VERIFIED', 'verified': account.code_verification_status === 'VERIFIED' || account.code_verification_status === 'EXPIRED' }">
                {{ account.code_verification_status === 'NOT_VERIFIED' ? 'Non vérifié' : 'Vérifié' }}
              </p>
            </div>
            <div class="account-actions">
              <button class="menu-btn" @click="toggleMenu(account._id)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="1"/>
                  <circle cx="19" cy="12" r="1"/>
                  <circle cx="5" cy="12" r="1"/>
                </svg>
              </button>
              <div v-if="activeMenu === account._id" class="account-menu">
                <button v-if="account.idbot" class="menu-item" @click="confirmDissociateChatbot(account)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6L6 18M6 6l12 12"/>
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                  <span>Dissocier l'agent</span>
                </button>
                <button class="menu-item delete" @click="confirmDelete(account)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                  <span>Supprimer</span>
                </button>
              </div>
            </div>
          </div>
          <div class="account-details">
            <div class="detail-row">
              <span class="detail-label">Numéro de téléphone:</span>
              <span class="detail-value">{{ account.display_phone_number }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">ID Configuration:</span>
              <span class="detail-value">{{ account.config_id }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Date d'ajout:</span>
              <span class="detail-value">{{ formatDate(account.created_at) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">État:</span>
              <span class="detail-value" :class="{ 'status-verified': account.code_verification_status === 'VERIFIED' || account.code_verification_status === 'EXPIRED', 'status-not-verified': account.code_verification_status === 'NOT_VERIFIED' }">
                {{ (account.code_verification_status === 'VERIFIED' || account.code_verification_status === 'EXPIRED') ? 'Vérifié' : 'Non vérifié' }}
              </span>
            </div>

            <!-- Section Agent -->
            <div v-if="account.code_verification_status === 'VERIFIED' || account.code_verification_status === 'EXPIRED'" class="chatbot-section">
              <div class="detail-row">
                <span class="detail-label">{{ account.idbot ? 'Agent:' : 'Aucun agent associé' }}</span>
                <div v-if="!account.idbot" class="detail-value-with-action">
                  <button class="link-chatbot-btn" @click="openLinkChatbotModal(account)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M8 12h8M12 8v8M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0z"/>
                    </svg>
                    Associer un agent
                  </button>
                </div>
                <div v-else class="detail-value-with-action">
                  <router-link 
                    :to="`/dashboard/chatbots/${account.idbot}/home`" 
                    class="chatbot-tag clickable"
                    title="Ouvrir la page de l'agent"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="11" width="18" height="10" rx="2"/>
                      <circle cx="12" cy="5" r="2"/>
                      <path d="M12 7v4"/>
                      <line x1="8" y1="16" x2="8.01" y2="16"/>
                      <line x1="16" y1="16" x2="16.01" y2="16"/>
                    </svg>
                    {{ getChatbotName(account) }}
                    <svg class="arrow-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14"/>
                      <path d="M12 5l7 7-7 7"/>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Section de vérification -->
            <div v-if="account.code_verification_status === 'NOT_VERIFIED'" class="verification-section">
              <div v-if="!verificationData.showInput || verificationData.currentAccountId !== account._id">
                <button class="verify-btn" @click="showVerificationConfirm(account)">
                  Vérifier le numéro de téléphone
                </button>
              </div>
              <div v-else class="verification-input-section">
                <div class="verification-header">
                  <div class="verification-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M22 2L11 13"/>
                      <path d="M22 2L15 22L11 13L2 9L22 2z"/>
                    </svg>
                  </div>
                  <div class="verification-title">
                    <h4>Vérification par SMS</h4>
                    <p>Entrez le code de vérification pour {{ account.display_phone_number }}</p>
                  </div>
                </div>
                
                <div class="form-group">
                  <label>Code de vérification</label>
                  <div class="code-input-container">
                    <input 
                      v-model="verificationData.code" 
                      type="text" 
                      placeholder="Exemple: 123456"
                      class="verification-input"
                      maxlength="6"
                    >
                    <div class="input-info">
                      Le code expire dans 10 minutes
                    </div>
                  </div>
                </div>
                
                <div class="verification-actions">
                  <button class="resend-btn" @click="sendVerificationCode(account)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M21 12a9 9 0 11-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/>
                    </svg>
                    Renvoyer le code
                  </button>
                  <button class="verify-code-btn" @click="verifyCode(account)">
                    Vérifier le code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="accounts.length === 0" class="empty-state">
        <svg fill="currentColor" width="64" height="64" viewBox="0 0 506.964 506.964">
          <g transform="translate(2 1)">
            <g>
              <g>
                <path d="M252.321-1C113.83-1,1.357,111.472,1.357,249.125c0,43.646,11.751,85.613,33.574,124.223L-2,505.964l135.134-36.092
                  c39.449,20.984,80.577,32.734,119.187,32.734c136.813,0,252.643-115.83,252.643-253.482S391.652-1,252.321-1z M252.321,485.82
                  c-36.931,0-76.38-11.751-114.151-32.734l-3.357-1.679L21.502,482.462L52.557,370.83l-1.679-3.357
                  c-20.984-36.092-32.734-77.22-32.734-118.348c0-128.42,104.918-233.338,234.177-233.338
                  c130.098,0,235.856,104.918,235.856,233.338S379.902,485.82,252.321,485.82z M251.482,444.692c-33.574,0-67.987-10.911-99.882-30.216l-10.072-6.715
                  l-61.272,15.108l16.787-58.754l-6.715-10.911c-20.144-31.056-30.216-67.148-30.216-104.079
                  c0-104.918,86.452-191.37,192.21-191.37c106.597,0,193.889,86.452,193.889,191.37
                  C446.21,356.561,358.918,443.852,251.482,444.692z"/>
                <path d="M378.223,295.289l-52.879-24.341c-7.554-3.357-15.108-0.839-20.144,5.036l-20.144,26.02
                  c-15.108-5.875-57.075-24.341-81.416-69.666l18.466-21.823c4.197-5.036,5.036-11.751,2.518-17.626l-22.662-53.718
                  c-2.518-5.875-7.554-10.072-14.269-10.072l-15.948-0.839c-6.715,0-14.269,1.679-19.305,6.715
                  c-7.554,6.715-21.823,20.984-26.02,40.289c-5.875,27.698,3.357,60.433,26.859,92.328
                  c14.269,20.144,57.915,79.738,141.849,103.239c8.393,2.518,16.787,3.357,24.341,3.357c14.269,0,27.698-4.197,39.449-10.911
                  c13.43-8.393,22.662-22.662,26.02-37.771l2.518-11.751C389.134,306.2,384.938,298.646,378.223,295.289z M367.311,321.308
                  c-2.518,10.911-9.233,20.984-18.466,26.859c-14.269,9.233-31.056,10.911-49.521,5.875
                  c-78.059-21.823-119.187-78.059-132.616-96.525c-20.144-27.698-28.538-56.236-23.502-78.898
                  c3.357-15.108,14.269-26.02,20.984-31.895c1.679-1.679,4.197-2.518,6.715-2.518l16.787,1.679l22.662,52.879l-20.144,22.662
                  c-3.357,4.197-4.197,10.911-1.679,15.948c27.698,53.718,78.059,74.702,93.167,79.738c5.875,1.679,11.751,0,15.948-5.036
                  l20.144-26.859l52.879,24.341L367.311,321.308z"/>
              </g>
            </g>
          </g>
        </svg>
        <h3>Aucun compte WhatsApp trouvé</h3>
        <p>Commencez par associer votre premier compte WhatsApp</p>
        <button class="create-btn" @click="showAddModal = true">Associer un compte</button>
      </div>
    </div>

    <!-- Modal d'ajout d'un compte -->
    <div v-if="showAddModal" class="modal-overlay" @click.self="showAddModal = false">
      <div class="modal-content">
        <!-- Étape 1: Choisir le type de compte -->
        <div v-if="addStep === 1" class="modal-body">
          <div class="modal-header">
            <h3>Associer un compte WhatsApp</h3>
            <button class="close-btn" @click="showAddModal = false">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="account-type-choice">
            <h4>Quel type de compte souhaitez-vous créer ?</h4>
            <div class="choice-options">
              <div 
                class="choice-option" 
                :class="{ 'selected': selectedType === 'customer_support' }"
                @click="selectedType = 'customer_support'"
              >
                <div class="option-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                    <path d="M9 10h.01M12 10h.01M15 10h.01"/>
                  </svg>
                </div>
                <div class="option-info">
                  <h5>Service client</h5>
                  <p>Pour le support client, l'assistance et les services après-vente</p>
                </div>
                <div class="option-check">
                  <svg v-if="selectedType === 'customer_support'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 6L9 17l-5-5"/>
                  </svg>
                </div>
              </div>
              
              <div 
                class="choice-option" 
                :class="{ 'selected': selectedType === 'ecommerce' }"
                @click="selectedType = 'ecommerce'"
              >
                <div class="option-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 3h18v18H3zM9 9l3 3 6-6"/>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7"/>
                    <path d="M16 6l-4 4-4-4"/>
                  </svg>
                </div>
                <div class="option-info">
                  <h5>E-commerce</h5>
                  <p>Pour la vente en ligne, les commandes et la gestion des produits</p>
                </div>
                <div class="option-check">
                  <svg v-if="selectedType === 'ecommerce'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 6L9 17l-5-5"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="cancel-btn" @click="showAddModal = false">Annuler</button>
            <button class="next-btn" @click="nextStep" :disabled="!selectedType">Suivant</button>
          </div>
        </div>
        
        <!-- Étape 2: Formulaire d'informations du compte -->
      
      </div>
    </div>

    <!-- Modal de confirmation de suppression -->
    <div v-if="showDeleteModal" class="modal-overlay" @click.self="showDeleteModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Confirmer la suppression</h3>
          <button class="close-btn" @click="showDeleteModal = false">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <p>Êtes-vous sûr de vouloir supprimer ce compte WhatsApp ? Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="showDeleteModal = false">Annuler</button>
          <button class="delete-btn" @click="deleteAccount">Supprimer</button>
        </div>
      </div>
    </div>

    <!-- Modal de confirmation de dissociation de l'agent -->
    <div v-if="showDissociateModal" class="modal-overlay" @click.self="showDissociateModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Confirmer la dissociation</h3>
          <button class="close-btn" @click="showDissociateModal = false">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="warning-message">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 8v4M12 16h.01"/>
            </svg>
            <p>Êtes-vous sûr de vouloir dissocier cet agent du compte WhatsApp ? <span class="warning-highlight">Cette action est réversible mais peut affecter vos services.</span></p>
          </div>
          
          <div class="form-group confirmation-form">
            <label>Pour confirmer, tapez <strong>"DISSOCIER"</strong> en majuscules</label>
            <input 
              v-model="dissociateConfirmation" 
              type="text" 
              placeholder="DISSOCIER"
              :class="{ 'error': dissociateConfirmation && dissociateConfirmation !== 'DISSOCIER' }"
            >
            <span v-if="dissociateConfirmation && dissociateConfirmation !== 'DISSOCIER'" class="error-message">
              Veuillez taper exactement "DISSOCIER" en majuscules
            </span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="showDissociateModal = false">Annuler</button>
          <button 
            class="delete-btn" 
            @click="dissociateChatbot" 
            :disabled="dissociateConfirmation !== 'DISSOCIER'"
          >
            Dissocier
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de confirmation de vérification -->
    <div v-if="showVerificationModal" class="modal-overlay" @click.self="showVerificationModal = false">
      <div class="modal-content verification-modal">
        <div class="modal-header">
          <h3>Vérification du numéro de téléphone</h3>
          <button class="close-btn" @click="showVerificationModal = false">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="verification-info">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#1EA355" stroke-width="2">
              <path d="M22 2L11 13"/>
              <path d="M22 2L15 22L11 13L2 9L22 2z"/>
            </svg>
            <h4>Vérification par SMS</h4>
            <p>Un code de vérification va être envoyé au numéro :</p>
            <p class="phone-highlight">{{ selectedAccountForVerification?.display_phone_number }}</p>
            
            <div v-if="!verificationData.showInput" class="verification-note">
              Cliquez sur "Envoyer" pour recevoir le code de vérification.
            </div>
            
            <div v-else class="verification-input-wrapper">
              <div class="form-group">
                <label>Code de vérification</label>
                <div class="code-input-container">
                  <input 
                    v-model="verificationData.code" 
                    type="text" 
                    placeholder="Exemple: 123456"
                    class="verification-input"
                    maxlength="6"
                  >
                  <div class="input-info">
                    Le code expire dans 10 minutes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="showVerificationModal = false">Annuler</button>
          <button 
            v-if="!verificationData.showInput" 
            class="send-code-btn" 
            @click="sendVerificationCode(selectedAccountForVerification)"
          >
            Envoyer le code
          </button>
          <button 
            v-else 
            class="verify-code-btn" 
            @click="verifyCode(selectedAccountForVerification)"
          >
            Vérifier le code
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de liaison avec un agent -->
    <div v-if="showLinkChatbotModal" class="modal-overlay" @click.self="showLinkChatbotModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Associer un agent</h3>
          <button class="close-btn" @click="showLinkChatbotModal = false">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        
        <div class="modal-body">
          <div v-if="loadingChatbots" class="loading-chatbots">
            <div class="loading-spinner">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-dashoffset="60">
                  <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
                </circle>
              </svg>
            </div>
            <p>Chargement des agents...</p>
          </div>
          
          <div v-else-if="chatbots.length === 0" class="no-chatbots">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              <path d="M12 8v4M12 16h.01"/>
            </svg>
            <h4>Aucun agent disponible</h4>
            <p>Vous devez d'abord créer un agent pour pouvoir l'associer à votre compte WhatsApp.</p>
            <button class="create-chatbot-btn" @click="goToCreateChatbot">
              Créer un agent
            </button>
          </div>
          
          <div v-else class="chatbot-selection">
            <p class="selection-info">
              Sélectionner l'agent à associer au compte WhatsApp
               
            </p>
            
            <div class="chatbots-list">
              <!-- Option pour créer un nouvel agent -->
              <div 
                class="chatbot-item create-new"
                @click="goToCreateChatbot"
              >
                <div class="chatbot-item-header">
                  <div class="chatbot-avatar create-avatar">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <path d="M12 5v14M5 12h14"/>
                    </svg>
                  </div>
                  <div class="chatbot-info">
                    <h4 class="chatbot-name">Créer un nouvel agent</h4>
                    <p class="chatbot-phone">Cliquez pour en créer un nouveau</p>
                  </div>
                </div>
                
              </div>

              <!-- Liste des agents existants -->
              <div 
                v-for="bot in chatbots" 
                :key="bot._id || bot.id" 
                class="chatbot-item"
                :class="{ 
                  'selected': selectedChatbot === (bot._id || bot.id),
                  'inactive': bot.status === 'inactive'
                }"
                @click="selectChatbot(bot._id || bot.id)"
              >
                <div class="chatbot-item-header chatbot-box-item">
                  <div class="chatbot-avatar">
                    <template v-if="bot.avatar === '/avatars/bot1.png'">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                        <path d="M9 10h.01M12 10h.01M15 10h.01"/>
                      </svg>
                    </template>
                    <img v-else :src="bot.avatar === '/avatars/bot1.png' ? 'https://placehold.co/250' : baseUrlImage+'/public/'+ bot.avatar" :alt="bot.bot_name" />
                  </div>
                  <div class="chatbot-info">
                    <h4 class="chatbot-name">{{ bot.bot_name }}</h4>
                    <p class="chatbot-phone">{{ bot.display_phone_number }}</p>
                  </div>
                  <div class="chatbot-status">
                    <span :class="bot.status">{{ bot.status === 'active' ? 'Actif' : 'Inactif' }}</span>
                  </div>
                </div>
                <div class="chatbot-item-body">
                  <p class="chatbot-description">{{ bot.description }}</p>
                  <div class="chatbot-stats">
                    <div class="stat">
                      <span class="stat-label">Utilisateurs</span>
                      <span class="stat-value">{{ bot.userCount }}</span>
                    </div>
                    <div class="stat">
                      <span class="stat-label">Interactions</span>
                      <span class="stat-value">{{ bot.interactionCount }}</span>
                    </div>
                  </div>
                </div>
                <div class="chatbot-select-indicator">
                  <svg v-if="selectedChatbot === bot._id" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 6L9 17l-5-5"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <button class="cancel-btn" @click="showLinkChatbotModal = false">Annuler</button>
          <button 
            v-if="chatbots.length > 0" 
            class="link-btn" 
            :disabled="!selectedChatbot"
            @click="linkChatbot"
          >
            Associer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import ProGate from '@/components/ProGate.vue';

export default {
  name: 'WhatsAppManagement',
  components: {
    PageHeader,
    ProGate
  },
  data() {
    return {
      showPaymentNotice: false,
      showMorePaymentDetails: false,
      baseUrlImage:   'https://api.peelo.io',
      accounts: [],
      loading: true,
      error: null,
      showAddModal: false,
      showDeleteModal: false,
      showDissociateModal: false,
      accountToDissociate: null,
      dissociateConfirmation: '',
      
      activeMenu: null,
      accountToDelete: null,
      selectedType: 'customer_support',
      addStep: 1,
      chatbots: [],
      loadingChatbots: false,
      selectedChatbot: null,
      showLinkChatbotModal: false,
      accountToLink: null,
      newAccount: {
        type: '',
        config_id: '',
        auth_code: null,
        phone_number: '',
        description: '',
        phone_number_id: null,
        waba_id: null,
        business_id: null,
        id: null,
        code_verification_status: 'NOT_VERIFIED'
      },
      metaSignupState: {
        authCode: null,
        whatsappData: null,
        isComplete: false
      },
      showVerificationModal: false,
      selectedAccountForVerification: null,
      verificationData: {
        code: '',
        showInput: false,
        currentAccountId: null
      },
      notification: {
        show: false,
        message: '',
        type: 'success',
        timeout: null
      },
    };
  },

  watch: {
    accounts: {
      handler(newAccounts) {
        this.showPaymentNotice = newAccounts.length > 0;
      },
      immediate: true
    }
  },

  methods: {
    // Naviguer vers la page de création de chatbot
    goToCreateChatbot() {
      // Stocker l'URL actuelle pour y revenir après la création
      localStorage.setItem('returnToAfterChatbotCreation', this.$route.fullPath);
      // Ajouter un paramètre de requête pour indiquer le retour à la page de gestion WhatsApp
      this.$router.push({
        path: '/dashboard/chatbots/create',
        query: { returnTo: 'whatsapp_management', accountId: this.$route.params.id }
      });
    },
    // Facebook SDK Initialization
    initFacebookSDK() {
      return new Promise((resolve, reject) => {
        // Vérifier si le SDK est déjà chargé
        if (typeof FB !== 'undefined') {
          consoleLog('Facebook SDK already loaded');
          resolve();
          return;
        }

        // Timeout pour éviter d'attendre indéfiniment
        const timeout = setTimeout(() => {
          reject(new Error('Facebook SDK loading timeout'));
        }, 15000); // 15 secondes

        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            clearTimeout(timeout);
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          js.crossOrigin = "anonymous";
          js.async = true;
          js.defer = true;
          
          js.onerror = function() {
            clearTimeout(timeout);
            reject(new Error('Failed to load Facebook SDK'));
          };
          
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        window.fbAsyncInit = function() {
          try {
            FB.init({
              appId: '1668577657360308',
              autoLogAppEvents: true,
              xfbml: true,
              version: 'v22.0'
            });
            consoleLog('Facebook SDK initialized successfully');
            clearTimeout(timeout);
            resolve();
          } catch (error) {
            clearTimeout(timeout);
            reject(error);
          }
        };
      });
    },

    // WhatsApp Signup Launch
    launchWhatsAppSignup(configId) {
      return new Promise((resolve, reject) => {
        // Vérifier si le SDK Facebook est prêt
        if (typeof FB === 'undefined') {
          reject(new Error('Facebook SDK not loaded'));
          return;
        }

        // Vérifier l'état de connexion Facebook
        FB.getLoginStatus((statusResponse) => {
          consoleLog('Facebook login status:', statusResponse);
          
          // Procéder avec le login WhatsApp
          FB.login((response) => {
            consoleLog('WhatsApp signup response:', response);
            
            if (response.authResponse && response.authResponse.code) {
              resolve({
                code: response.authResponse.code,
                response: response
              });
            } else if (response.error) {
              consoleError('Facebook login error:', response.error);
              reject(new Error(`Facebook login error: ${response.error.message || response.error}`));
            } else if (response.status === 'not_authorized') {
              reject(new Error('User cancelled the login or did not fully authorize'));
            } else {
              reject(new Error('Login failed - unknown error'));
            }
          }, {
            config_id: configId,
            response_type: 'code',
            override_default_response_type: true,
            extras: {
              setup: {},
              featureType: 'whatsapp_business_app_onboarding',
              sessionInfoVersion: '3'
            }
          });
        });
      });
    },

    // API Calls
    async getAccounts() {
      
      const userData = localStorage.getItem('user');
      if (!userData) {
        throw new Error('Données utilisateur non trouvées');
      }
      
      const userObj = JSON.parse(userData);
      const token = userObj.data.token;
      

      const response = await axiosPeelo.get('/strong/whatsapp/accounts', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return response.data;
    },

    async createAccount(accountData) {
      
      
      const response = await axiosPeelo.post('/strong/create/whatsapp/account', accountData);
      return response.data;
    },



    async updateAccount(accountId, updateData) {
      const response = await axiosPeelo.put(`/strong/whatsapp/accounts/${accountId}`, updateData);
      return response.data;
    },

    // Event Handlers
    async handleWhatsAppSignupResponse(data) {
      
      

      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        if (['FINISH', 'FINISH_ONLY_WABA', 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING'].includes(data.event)) {
          // Stocker les données WhatsApp
          this.metaSignupState.whatsappData = {
            phone_number_id: data.data.phone_number_id,
            waba_id: data.data.waba_id,
            business_id: data.data.business_id
          };
          
          this.checkAndCreateAccount();
        } else if (data.event === 'CANCEL') {
          this.error = data.data.error_message
            ? `Error: ${data.data.error_message}`
            : `Setup abandoned at step: ${data.data.current_step}`;
        }
      }
    },

    async nextStep() {
      this.error = null;
      
      if (!this.selectedType) {
        this.error = 'Please select an account type first';
        return;
      }

      try {
        // Vérifier si le SDK Facebook est chargé
        if (typeof FB === 'undefined') {
          this.showNotificationMessage('SDK Facebook en cours de chargement, veuillez réessayer dans quelques secondes', 'error');
          return;
        }

        // Configuration Embedded Signup v4 (la même pour tous les types de compte)
        const configId = '2117067702537293';

        this.newAccount = {
          ...this.newAccount,
          type: this.selectedType,
          config_id: configId,
        };

        // Réinitialiser l'état de synchronisation
        this.metaSignupState = {
          authCode: null,
          whatsappData: null,
          isComplete: false
        };
        
        consoleLog('Launching WhatsApp signup with configId:', configId);
        const { code, response } = await this.launchWhatsAppSignup(configId);
        
        consoleLog('WhatsApp signup successful, code:', code);
        
        // Mettre à jour l'état avec le code d'authentification
        this.metaSignupState.authCode = code;
        this.checkAndCreateAccount();
        
      } catch (err) {
        consoleError('Error launching signup:', err);
        
        // Gestion des erreurs spécifiques
        if (err.message.includes('Facebook SDK not loaded')) {
          this.showNotificationMessage('SDK Facebook non chargé. Veuillez actualiser la page et réessayer.', 'error');
        } else if (err.message.includes('User cancelled')) {
          this.showNotificationMessage('Connexion annulée par l\'utilisateur', 'error');
        } else if (err.message.includes('Facebook login error')) {
          this.showNotificationMessage(`Erreur Facebook: ${err.message}`, 'error');
        } else if (err.message.includes('Failed to fetch')) {
          this.showNotificationMessage('Erreur de connexion. Vérifiez votre connexion internet et réessayez.', 'error');
        } else {
          this.showNotificationMessage('Erreur lors du lancement de la configuration WhatsApp', 'error');
        }
        
        this.error = err.message;
      }
    },

    async fetchAccounts(fromUrlParams = false, accountIdToFind = null) {
       
      //if (this.loading) return; // Éviter les appels multiples si déjà en cours
      
      this.loading = true;
      this.error = null;
      
      try {
        const response = await this.getAccounts();
        this.accounts = response;
        
        // Si un accountId est spécifié, trouver le compte correspondant
        if (accountIdToFind && this.accounts.length > 0) {
          
          this.accountToLink = this.accounts.find(account => account._id === accountIdToFind);
          
          
          // Si le compte est trouvé et que nous venons des paramètres d'URL, ouvrir le modal
          if (this.accountToLink && fromUrlParams) {
            
            this.showLinkChatbotModal = true;
            
            // Si les chatbots ne sont pas encore chargés, les charger
            if (this.chatbots.length === 0) {
              const chatbotIdToFind = this.pendingParams?.chatbotIdBi;
              await this.fetchChatbots(fromUrlParams, chatbotIdToFind);
            }
          }
        }
        
        // Si au moins un compte vérifié n'a pas de bot, charger la liste des chatbots
        const needsChatbots = this.accounts.some(
          account => account.code_verification_status === 'VERIFIED' && !account.idbot
        );
        
        if (needsChatbots && this.chatbots.length === 0) {
          await this.fetchChatbots();
        }
      } catch (err) {
        this.error = err.response?.data?.error || 'Failed to load WhatsApp accounts';
        this.showNotificationMessage(this.error, 'error');
      } finally {
        this.loading = false;
      }
    },

    async deleteAccount() {
      if (!this.accountToDelete) return;
      
      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          throw new Error('Données utilisateur non trouvées');
        }
        
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;

        await axiosPeelo.delete(`/strong/whatsapp/accounts/${this.accountToDelete._id}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        // Filtrer le compte supprimé de la liste
        this.accounts = this.accounts.filter(acc => acc._id !== this.accountToDelete._id);
        
        // Fermer le modal et nettoyer
        this.showDeleteModal = false;
        this.accountToDelete = null;
        this.activeMenu = null;
        
        this.showNotificationMessage('Compte WhatsApp supprimé avec succès', 'success');
      } catch (err) {
        consoleError('Error deleting account:', err);
        this.showNotificationMessage(
          err.response?.data?.error || 'Erreur lors de la suppression du compte WhatsApp',
          'error'
        );
      }
    },

    async editAccount(account) {
      try {
        const updatedData = {
          ...account,
          code_verification_status: account.code_verification_status
        };
        
        await this.updateAccount(account.id, updatedData);
        await this.fetchAccounts();
      } catch (err) {
        this.error = err.response?.data?.error || 'Failed to update WhatsApp account';
      }
      this.activeMenu = null;
    },

    resetForm() {
      this.showAddModal = false;
      this.addStep = 1;
      this.selectedType = '';
      this.newAccount = {
        type: '',
        config_id: '',
        code_verification_status: 'NOT_VERIFIED',
        auth_code: null,
        phone_number: '',
        description: '',
        phone_number_id: null,
        waba_id: null,
        business_id: null,
        id: null
      };
      // Réinitialiser l'état de synchronisation
      this.metaSignupState = {
        authCode: null,
        whatsappData: null,
        isComplete: false
      };
    },

    toggleMenu(accountId) {
      this.activeMenu = this.activeMenu === accountId ? null : accountId;
    },

    confirmDelete(account) {
      this.accountToDelete = account;
      this.showDeleteModal = true;
      this.activeMenu = null;
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    addAccount() {
      const newId = this.accounts.length ? Math.max(...this.accounts.map(a => a.id)) + 1 : 1;
      
      const accountToAdd = {
        id: newId,
        ...this.newAccount
      };
      
      this.accounts.push(accountToAdd);
      this.resetForm();
    },

    async checkAndCreateAccount() {
      
      // Vérifier si nous avons toutes les données nécessaires
      if (this.metaSignupState.authCode && this.metaSignupState.whatsappData && !this.metaSignupState.isComplete) {
        try {
          // Marquer comme complet pour éviter les doublons
          this.metaSignupState.isComplete = true;

          // Préparer les données du compte
          const accountData = {
            ...this.newAccount,
            auth_code: this.metaSignupState.authCode,
            ...this.metaSignupState.whatsappData
            
          };

          
          const result = await this.createAccount(accountData);
          

          await this.fetchAccounts();
          this.showAddModal = false;
          this.resetForm();
        } catch (err) {
          consoleError('Error creating account:', err);
          this.error = err.response?.data?.error || 'Failed to create WhatsApp account';
          // Réinitialiser l'état en cas d'erreur
          this.metaSignupState.isComplete = false;
        }
      } else {
         
      }
    },

    showVerificationConfirm(account) {
      this.selectedAccountForVerification = account;
      this.showVerificationModal = true;
    },

    showVerificationInput(account) {
      // Cette méthode simule le retour de l'API d'envoi de code
      this.verificationData = {
        code: '',
        showInput: true,
        currentAccountId: account._id
      };
      this.showVerificationModal = false;
      this.showNotificationMessage('Veuillez entrer le code de vérification', 'success');
    },

    async sendVerificationCode(account) {
      consoleLog('sendVerificationCode', account);
      if (!account) return;

      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          consoleError('Données utilisateur non trouvées');
          return;
        }
        
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;

        if (!token) {
          consoleError('Token non trouvé dans les données utilisateur');
          return;
        }

        // Pour le développement, on peut simuler la réponse de l'API
        // En production, décommenter le code ci-dessous
        consoleLog(`sendVerificationCode axiosPeelo.post('/strong/send/code',`);
        
        const response = await axiosPeelo.post('/strong/send/code', { 
          idwhatsapp: account._id
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        /* */

        consoleLog('sendVerificationCode response', JSON.stringify(response.data, null, 2) );

        // Simulation de la réponse positive
        this.verificationData = {
          code: '',
          showInput: true,
          currentAccountId: account._id
        };
        
        this.showNotificationMessage('Un code de vérification a été envoyé par SMS', 'success');
      } catch (err) {
        consoleError('Error sending verification code:', err);
        this.showNotificationMessage(
          err.response?.data?.error || 'Erreur lors de l\'envoi du code de vérification', 
          'error'
        );
      }
    },

    async verifyCode(account) {
      if (!this.verificationData.code) {
        this.showNotificationMessage('Veuillez entrer le code de vérification', 'error');
        return;
      }

      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          consoleError('Données utilisateur non trouvées');
          return;
        }
        
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;

        if (!token) {
          consoleError('Token non trouvé dans les données utilisateur');
          return;
        }

        const response = await axiosPeelo.post('/strong/check/code', {
          idwhatsapp: account._id,
          code: this.verificationData.code
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.data && response.data.success) {
          // Mise à jour réactive directe des propriétés
          account.code_verification_status = 'VERIFIED';
          this.verificationData = {
            code: '',
            showInput: false,
            currentAccountId: null
          };
          this.showVerificationModal = false;
          
          this.showNotificationMessage('Numéro de téléphone vérifié avec succès', 'success');
          
          // Rafraîchir la liste des comptes
          await this.fetchAccounts();
        } else {
          throw new Error(response.data.message || 'Code de vérification incorrect');
        }
      } catch (err) {
        consoleError('Error verifying code:', err);
        this.showNotificationMessage(
          err.response?.data?.message || 'Code de vérification incorrect',
          'error'
        );
      }
    },

    showNotificationMessage(message, type = 'success') {
      // Clear any existing timeout
      if (this.notification.timeout) {
        clearTimeout(this.notification.timeout);
      }

      // Set notification
      this.notification = {
        show: true,
        message,
        type,
        timeout: setTimeout(() => {
          this.notification.show = false;
        }, 5000)
      };
    },

    // Nouvelle méthode pour charger les chatbots
    async fetchChatbots(fromUrlParams = false, chatbotIdToFind = null) {
      
      this.loadingChatbots = true;
      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          throw new Error('Données utilisateur non trouvées');
        }
        
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;

        const response = await axiosPeelo.get('/get/list/chatbots', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.data && response.data.chatbots) {
          this.chatbots = response.data.chatbots;
          
          // Si un chatbotId est spécifié, trouver le chatbot correspondant
          if (chatbotIdToFind && this.chatbots.length > 0) {
            
            this.chatbotToLink = this.chatbots.find(chatbot => chatbot._id === chatbotIdToFind);
            
            
            // Si le chatbot est trouvé et que nous avons déjà un compte sélectionné, préparer l'association
            if (this.chatbotToLink && this.accountToLink && fromUrlParams) {
              
              this.selectedChatbot = this.chatbotToLink._id;
            }
          }
        } else {
          throw new Error('Format de réponse invalide');
        }
      } catch (error) {
        consoleError('Error fetching chatbots:', error);
        this.showNotificationMessage(
          error.response?.data?.error || 'Erreur lors du chargement des chatbots',
          'error'
        );
      } finally {
        this.loadingChatbots = false;
      }
    },

    // Nouvelle méthode pour ouvrir le modal de liaison avec un chatbot
    openLinkChatbotModal(account) {
      
      
      this.accountToLink = account;
      this.showLinkChatbotModal = true;
      if (this.chatbots.length === 0) {
        this.fetchChatbots();
      }
    },

    getChatbotName(account) {
      
      
      if (account && account.idbot && account.bot_name) {
        return account.bot_name;
      }
      return 'Chatbot non trouvé';
    },

    async linkChatbot() {
      
      
      
      
      if (!this.selectedChatbot || !this.accountToLink) {
        
        
        
        this.showNotificationMessage('Veuillez sélectionner un chatbot', 'error');
        return;
      }

      try {
        const userData = localStorage.getItem('user');
        if (!userData) {
          throw new Error('Données utilisateur non trouvées');
        }
        
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;
        
        
        
        const response = await axiosPeelo.post('/strong/setup/association/chatbot', {
          idwhatsapp: this.accountToLink._id,
          idbot: this.selectedChatbot
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        
        
        // Vérifier si la réponse contient un message d'association réussie ou un indicateur de succès
        if (response.data && (response.data.message === "Association réussie" || response.data.success)) {
          // Afficher les détails du bot associé si disponible
          if (response.data.bot) {
            
          }
          
          this.showNotificationMessage('Chatbot associé avec succès', 'success');
          await this.fetchAccounts();
          this.showLinkChatbotModal = false;
          this.selectedChatbot = null;
          this.accountToLink = null;
        } else {
          throw new Error(response.data.message || 'Erreur lors de la liaison du chatbot');
        }
      } catch (err) {
        consoleError('Error linking chatbot:', err);
        this.showNotificationMessage(
          err.response?.data?.error || 'Erreur lors de la liaison du chatbot',
          'error'
        );
      }
    },

    goToCreateChatbot() {
      this.showLinkChatbotModal = false;
      // Ajouter un paramètre de requête pour indiquer le retour à la page de gestion WhatsApp
      this.$router.push({
        path: '/dashboard/chatbots/create',
        query: { returnTo: 'whatsapp_management', openpopupwhatsapp: 'true', accountId: this.accountToLink._id }
      });
    },

    selectChatbot(botId) {
      
      this.selectedChatbot = botId;
      
    },

    confirmDissociateChatbot(account) {
      this.accountToDissociate = account;
      this.showDissociateModal = true;
      this.dissociateConfirmation = '';
      this.activeMenu = null;
    },

    async dissociateChatbot() {
      // Dissocie le chatbot du compte WhatsApp
      if (!this.accountToDissociate || !this.accountToDissociate.idbot) return;
      try {
        const userData = localStorage.getItem('user');
        if (!userData) throw new Error('Données utilisateur non trouvées');
        const userObj = JSON.parse(userData);
        const token = userObj.data.token;
        const response = await axiosPeelo.post('/strong/setup/dissociation/chatbot', {
          idwhatsapp: this.accountToDissociate._id,
          idbot: this.accountToDissociate.idbot
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        if (response.data && (response.data.message === 'Dissociation réussie' || response.data.success)) {
          this.showNotificationMessage('Chatbot dissocié avec succès', 'success');
          this.showDissociateModal = false;
          this.dissociateConfirmation = '';
          this.accountToDissociate = null;
          await this.fetchAccounts();
        } else {
          throw new Error(response.data.message || 'Erreur lors de la dissociation du chatbot');
        }
      } catch (err) {
        consoleError('Erreur lors de la dissociation du chatbot:', err);
        this.showNotificationMessage(
          err.response?.data?.error || 'Erreur lors de la dissociation du chatbot',
          'error'
        );
      }
    },

    async copyToClipboard(text, type) {
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
        this.showNotificationMessage(`${type} copié dans le presse-papier`, 'success');
      } catch (err) {
        consoleError('Failed to copy to clipboard:', err);
        this.showNotificationMessage('Impossible de copier le texte', 'error');
      }
    },
  },

  mounted() {
    // Charger les comptes WhatsApp immédiatement, sans attendre l'initialisation du SDK Facebook
    this.fetchAccounts();
    
    // Vérifier si le paramètre openpopupwhatsapp est présent dans l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const openPopup = urlParams.get('openpopupwhatsapp');
    const accountIdBi = urlParams.get('accountId');
    const chatbotIdBi = urlParams.get('chatbotId');
    
    
    
    
    
    // Stocker les paramètres pour les utiliser après le chargement des données si nécessaire
    this.pendingParams = {
      openPopup,
      accountIdBi,
      chatbotIdBi
    };
    
    if (openPopup === 'true') {
      
      
      this.showLinkChatbotModal = true;
      
      // Si les comptes sont déjà chargés, trouver le compte correspondant
      if (accountIdBi && this.accounts.length > 0) {
        this.accountToLink = this.accounts.find(account => account._id === accountIdBi);
        
      } 
      // Sinon, forcer le chargement des comptes
      else if (accountIdBi) {
        
        this.fetchAccounts(true, accountIdBi);
      }
      
      // Si les chatbots sont déjà chargés, trouver le chatbot correspondant
      if (chatbotIdBi && this.chatbots.length > 0) {
        this.chatbotToLink = this.chatbots.find(chatbot => chatbot._id === chatbotIdBi);
        
      }
      // Sinon, forcer le chargement des chatbots
      else if (chatbotIdBi) {
        
        this.fetchChatbots(true, chatbotIdBi);
      }
    }
    
    // Initialiser le SDK Facebook en parallèle
    this.initFacebookSDK()
      .then(() => {
        // Setup WhatsApp signup listener après l'initialisation du SDK
        window.addEventListener('message', (event) => {
          if (!event.origin.endsWith('facebook.com')) return;
          try {
            
            const data = JSON.parse(event.data);
            

            if (data.type === 'WA_EMBEDDED_SIGNUP') {
              this.handleWhatsAppSignupResponse(data);
            }
          } catch (error) {
            this.handleWhatsAppSignupResponse(event.data);
          }
        });
      })
      .catch(err => {
        consoleError('Erreur lors de l\'initialisation du SDK Facebook:', err);
        // Ne pas définir this.error ici pour ne pas masquer les comptes WhatsApp
        // qui ont déjà été chargés
        this.showNotificationMessage('Erreur lors de l\'initialisation du SDK Facebook. Certaines fonctionnalités pourraient ne pas fonctionner correctement.', 'error');
      });
  }
};
</script>

<style scoped>
.whatsapp-management {
  padding: 24px;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
}

.header-title h1 {
  font-size: 42px;
  font-weight: 600;
  color: #1A1D1F;
  margin: 0;
}

.header-subtitle {
  color: #6F767E;
  font-size: 15px;
  margin-top: 8px;
  font-weight: 500;
}

.add-account-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #1EA355; /* Vert plus doux */
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-account-btn:hover {
  background: #167F42; /* Vert plus foncé et doux */
  transform: translateY(-1px);
}

.loading-state,
.error-state {
  text-align: center;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: #F9FAFB;
  border-radius: 12px;
  margin: 20px 0;
}

.loading-state {
  color: #6F767E;
}

.loading-state p {
  margin-top: 16px;
  font-size: 16px;
}

.error-state {
  color: #EF4444;
  border: 1px dashed #FECACA;
  background-color: #FEF2F2;
}

.error-state svg {
  margin-bottom: 16px;
  color: #EF4444;
}

.error-state p {
  font-size: 16px;
  margin-bottom: 24px;
  max-width: 600px;
}

.retry-btn {
  padding: 8px 20px;
  background-color: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  color: #1F2937;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.retry-btn:hover {
  background-color: #F3F4F6;
  transform: translateY(-1px);
}

.accounts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.account-card {
  background: #FFFFFF;
  border: 1px solid #E8ECEF;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.account-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  border-color: #1EA355; /* Vert plus doux */
}

.account-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
  position: relative;
}

.account-icon {
  width: 48px;
  height: 48px;
  background: #1EA355; /* Vert plus doux */
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.account-info {
  flex: 1;
}

.account-info-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-icon {
  display: flex;
  align-items: center;
}

.status-icon.active svg {
  color: #1EA355; /* Vert plus doux */
}

.status-icon.inactive svg {
  color: #DC2626;
}

.account-info h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1A1D1F;
  margin: 0;
}

.account-subinfo {
  margin-top: 4px;
}

.account-subinfo .phone-number {
  font-size: 14px;
  color: #6B7280;
  margin: 0;
}

.account-subinfo .account-type {
  font-size: 14px;
  color: #6B7280;
  margin: 2px 0 0 0;
}

.account-actions {
  position: relative;
  z-index: 2;
}

.menu-btn {
  background: none;
  border: none;
  padding: 8px;
  color: #6F767E;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.menu-btn:hover {
  background: #E8ECEF;
  color: #1A1D1F;
}

.account-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #E8ECEF;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  z-index: 100;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  width: 100%;
  background: none;
  border: none;
  color: #1A1D1F;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
}

.menu-item:hover {
  background: #E8ECEF;
}

.menu-item.delete {
  color: #FF3B30;
}

.menu-item.delete:hover {
  background: #FFD5D5;
}

.account-details {
  padding-top: 16px;
  border-top: 1px solid #E8ECEF;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.detail-label {
  color: #6F767E;
  font-size: 14px;
}

.detail-value {
  font-weight: 500;
  color: #1A1D1F;
  font-size: 14px;
}

.status-verified {
  color: #1EA355; /* Vert plus doux */
}

.status-not-verified {
  color: #DC2626;
}

.verification-status {
  font-size: 12px;
  margin-top: 4px;
}

.verification-status.verified {
  color: #1EA355; /* Vert plus doux */
}

.verification-status.not-verified {
  color: #DC2626;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Header styles removed in favor of PageHeader component */
.modal-content {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #E8ECEF;
  margin-bottom: 20px;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1A1D1F;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  padding: 8px;
  color: #6F767E;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #E8ECEF;
  color: #1A1D1F;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #E8ECEF;
}

.cancel-btn, .back-btn {
  padding: 12px 24px;
  background: white;
  border: 1px solid #E8ECEF;
  border-radius: 8px;
  color: #1A1D1F;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn:hover, .back-btn:hover {
  background: #F9FAFB;
  border-color: #D1D5DB;
}

.next-btn, .save-btn {
  padding: 12px 24px;
  background: #1EA355; /* Vert plus doux */
  border: none;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.next-btn:hover, .save-btn:hover {
  background: #167F42; /* Vert plus foncé et doux */
}

.next-btn:disabled {
  background: #9CA3AF;
  cursor: not-allowed;
}

.delete-btn {
  padding: 12px 24px;
  background: #FF3B30;
  border: none;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background: #E02D1E;
}

.delete-btn:disabled {
  background: #FF9A94;
  cursor: not-allowed;
}

.warning-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background-color: #FFF5F5;
  border-radius: 8px;
  margin-bottom: 24px;
  border-left: 4px solid #FF3B30;
}

.warning-message svg {
  color: #FF3B30;
  flex-shrink: 0;
  margin-top: 2px;
}

.warning-message p {
  margin: 0;
  color: #1A1D1F;
  font-size: 15px;
  line-height: 1.5;
}

.warning-highlight {
  font-weight: 600;
  color: #FF3B30;
}

.confirmation-form {
  background-color: #F9FAFB;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #E8ECEF;
}

.confirmation-form label {
  display: block;
  margin-bottom: 12px;
  font-size: 15px;
  color: #1A1D1F;
  font-weight: 500;
}

.confirmation-form strong {
  color: #FF3B30;
}

/* Account Type Choice */
.account-type-choice h4 {
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 18px;
  color: #1A1D1F;
  font-weight:lighter;
  text-align: center;
}

.choice-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.choice-option {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #E8ECEF;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.choice-option:hover {
  border-color: #1EA355; /* Vert plus doux */
  background-color: #F9FAFB;
}

.choice-option.selected {
  border-color: #1EA355; /* Vert plus doux */
  background-color: #F0FFF7; /* Fond vert très léger */
}

.option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: #1EA355; /* Vert plus doux */
  border-radius: 8px;
  color: white;
  margin-right: 16px;
}

.option-info {
  flex: 1;
}

.option-info h5 {
  margin: 0 0 4px 0;
  font-size: 16px;
  color: #1A1D1F;
}

.option-info p {
  margin: 0;
  font-size: 14px;
  color: #6F767E;
}

.option-check {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1EA355; /* Vert plus doux */
}

/* Account Form */
.account-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #1A1D1F;
  margin-bottom: 8px;
}

.id-info {
  font-size: 12px;
  color: #6F767E;
  font-weight: normal;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #E8ECEF;
  border-radius: 8px;
  font-size: 14px;
  color: #1A1D1F;
}

.form-group input:read-only {
  background-color: #F9FAFB;
}

.form-group textarea {
  height: 100px;
  resize: vertical;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 64px 0;
}

.empty-state svg {
  color: #6F767E;
  margin-bottom: 24px;
}

.empty-state h3 {
  font-size: 24px;
  font-weight: 600;
  color: #1A1D1F;
  margin: 0 0 8px 0;
}

.empty-state p {
  font-size: 16px;
  color: #6F767E;
  margin: 0 0 24px 0;
}

.create-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #1EA355; /* Vert plus doux */
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.create-btn:hover {
  background: #167F42; /* Vert plus foncé et doux */
  transform: translateY(-1px);
}

@media (max-width: 1200px) {
  .accounts-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .content-header {
    flex-direction: column;
    gap: 16px;
  }
  
  .header-actions {
    width: 100%;
  }
  
  .add-account-btn {
    width: 100%;
    justify-content: center;
  }
  
  .modal-content {
    width: 90%;
  }
}

.verification-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E8ECEF;
}

.verify-btn {
  width: 100%;
  padding: 8px 16px;
  background-color: #1EA355; /* Vert plus doux */
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.verify-btn:hover {
  background-color: #167F42; /* Vert plus foncé et doux */
}

.verification-input-section {
  margin-top: 12px;
}

.verification-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #E8ECEF;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 8px;
}

.verify-code-btn {
  width: 100%;
  padding: 8px 16px;
  background-color: #4F46E5;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.verify-code-btn:hover {
  background-color: #4338CA;
}

.form-group label {
  display: block;
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 4px;
}

.verification-modal {
  max-width: 480px;
}

.verification-info {
  text-align: center;
  padding: 20px 0;
}

.verification-info svg {
  margin-bottom: 16px;
  stroke: #1EA355; /* Vert plus doux */
}

.verification-info h4 {
  font-size: 18px;
  color: #1A1D1F;
  margin: 0 0 16px 0;
}

.verification-info p {
  color: #6B7280;
  margin: 8px 0;
}

.phone-highlight {
  font-size: 18px;
  color: #1EA355 !important; /* Vert plus doux */
  font-weight: 600;
  margin: 16px 0 !important;
}

.verification-note {
  font-size: 14px;
  color: #6B7280;
  font-style: italic;
}

.send-code-btn {
  padding: 12px 24px;
  background-color: #1EA355; /* Vert plus doux */
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.send-code-btn:hover {
  background-color: #167F42; /* Vert plus foncé et doux */
}

/* Notification styles */
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
}

.notification.success {
  background-color: #EBF7EE;
  color: #1EA355;
  border: 1px solid #D1E7DD;
}

.notification.error {
  background-color: #FEF2F2;
  color: #DC2626;
  border: 1px solid #FCA5A5;
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.notification-content svg {
  flex-shrink: 0;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Ensure verification input is visible */
.verification-input-section {
  opacity: 1;
  transition: all 0.3s ease;
  margin-top: 16px;
  padding: 16px;
  background-color: #F9FAFB;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
}

.verification-input-section .form-group {
  margin-bottom: 16px;
}

.verification-input-section label {
  display: block;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  font-weight: 500;
}

.verification-input-section input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  font-size: 16px;
  transition: all 0.2s ease;
}

.verification-input-section input:focus {
  outline: none;
  border-color: #1EA355;
  box-shadow: 0 0 0 2px rgba(30, 163, 85, 0.1);
}

.verification-input-section .verify-code-btn {
  width: 100%;
  margin-top: 8px;
}

.verification-input-wrapper {
  margin-top: 24px;
  padding: 16px;
  background-color: rgba(30, 163, 85, 0.05);
  border-radius: 8px;
}

.verification-input-wrapper .form-group {
  margin-bottom: 0;
}

.verification-input-wrapper label {
  color: #1F2937;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.verification-input-wrapper .code-input-container {
  position: relative;
}

.verification-input-wrapper .verification-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 18px;
  letter-spacing: 2px;
  text-align: center;
  transition: all 0.2s ease;
  font-family: monospace;
  background-color: white;
}

.verification-input-wrapper .verification-input:focus {
  outline: none;
  border-color: #1EA355;
  box-shadow: 0 0 0 3px rgba(30, 163, 85, 0.1);
}

.verification-input-wrapper .input-info {
  font-size: 12px;
  color: #6B7280;
  margin-top: 8px;
  text-align: center;
}

.verification-modal .modal-footer {
  margin-top: 24px;
}

.verification-modal .verify-code-btn {
  padding: 12px 24px;
  background-color: #1EA355;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.verification-modal .verify-code-btn:hover {
  background-color: #167F42;
}

/* Chatbot Section Styles */
.chatbot-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E8ECEF;
}

.link-chatbot {
  text-align: center;
}

.chatbot-info {
  flex: 1;
  min-width: 0;
  margin-right: 16px;
}

.link-chatbot-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 8px 16px;
  background-color: #1EA355;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.link-chatbot-btn:hover {
  background-color: #167F42;
}

.linked-chatbot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #F0FFF7;
  border-radius: 6px;
}

.chatbot-name {
  font-weight: 600;
  color: #1EA355;
}

/* Chatbot Modal Styles */
.loading-chatbots {
  text-align: center;
  padding: 32px 0;
}

.loading-chatbots .loading-spinner {
  margin-bottom: 16px;
}

.no-chatbots {
  text-align: center;
  padding: 32px 0;
}

.no-chatbots svg {
  color: #6B7280;
  margin-bottom: 16px;
}

.no-chatbots h4 {
  font-size: 18px;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.no-chatbots p {
  color: #6B7280;
  margin-bottom: 24px;
}

.create-chatbot-btn {
  padding: 8px 24px;
  background-color: #1EA355;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.create-chatbot-btn:hover {
  background-color: #167F42;
}

.chatbot-selection {
  padding: 16px 0;
}

.selection-info {
  margin-bottom: 14px;
  color: #1F2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 4px;
}

.selection-info strong {
  color: #1EA355;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatbot-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 14px;
  color: #1F2937;
  background-color: white;
}

.chatbot-select:focus {
  outline: none;
  border-color: #1EA355;
  box-shadow: 0 0 0 2px rgba(30, 163, 85, 0.1);
}

.link-btn {
  padding: 8px 24px;
  background-color: #1EA355;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.link-btn:hover {
  background-color: #167F42;
}

.link-btn:disabled {
  background-color: #9CA3AF;
  cursor: not-allowed;
}

.detail-value-with-action {
  display: flex;
  align-items: center;
  gap: 12px;
}

.no-chatbot {
  color: #6B7280;
  font-style: italic;
}

.link-chatbot-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #1EA355;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.link-chatbot-btn:hover {
  background-color: #167F42;
}

.link-chatbot-btn svg {
  width: 14px;
  height: 14px;
}

.chatbots-list {
  max-height: 400px;
  overflow-y: auto;
  margin: 20px 0;
  padding-right: 8px;
}

.chatbots-list::-webkit-scrollbar {
  width: 8px;
}

.chatbots-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.chatbots-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.chatbot-item {
  border: none;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  background-color: white;
  border: 1px solid white;
}

.chatbot-item:hover {
  transform: translateY(-2px);
  border: 1px solid #1EA355;
}

.chatbot-item.selected {
  border-color: #1EA355;
  background-color: #F0FFF7;
}

.chatbot-item.selected > .chatbot-box-item {
   background-color: #F0FFF7;
}

.chatbot-item.inactive {
  opacity: 0.7;
}

.chatbot-item.create-new {
  background-color: #F0FFF7;
  border: 1px dashed #1EA355;
  margin-bottom: 24px;
  height: auto;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.chatbot-item.create-new:hover {
  border-color: #167F42;
  background-color: #E6F7EE;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 163, 85, 0.15);
}

.chatbot-item.create-new .chatbot-avatar {
  background-color: #E6F7EE;
  color: #1EA355;
}

.chatbot-item.create-new .chatbot-name {
  color: #1EA355;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
}

.chatbot-item.create-new .chatbot-phone {
  color: #6F767E;
  font-size: 14px;
}

.chatbot-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.chatbot-box-item {
  background-color: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  border-bottom: 1px solid #E8ECEF;
}



.chatbot-item.create-new .chatbot-item-header {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 0;
}

.chatbot-avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background-color: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.create-avatar {
  background-color: white;
  color: #1EA355;
  border: 2px solid #1EA355;
}

.chatbot-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chatbot-name {
  font-size: 16px;
  font-weight: 600;
  color: #1A1D1F;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatbot-phone {
  font-size: 13px;
  color: #6F767E;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatbot-status {
  margin-left: auto;
  flex-shrink: 0;
}

.chatbot-status span {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}

.chatbot-status .active {
  background-color: #E6F7EE;
  color: #1EA355;
}

.chatbot-status .inactive {
  background-color: #F5F5F5;
  color: #6F767E;
}

.chatbot-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #E6F7EE;
  color: #1EA355;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
}

.chatbot-tag svg {
  color: #1EA355;
}

.chatbot-tag.clickable {
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  padding-right: 10px;
}

.chatbot-tag.clickable:hover {
  background-color: #D1F0E0;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(30, 163, 85, 0.1);
}

.chatbot-tag .arrow-icon {
  margin-left: 4px;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.chatbot-tag.clickable:hover .arrow-icon {
  transform: translateX(2px);
  opacity: 1;
}

.chatbot-item-body {
  margin-top: 8px;
}

.chatbot-description {
  font-size: 14px;
  color: #6F767E;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatbot-stats {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}

.stat {
  display: inline-block;
  margin-right: 24px;
  text-align: center;
  min-width: 80px;
}

.stat-label {
  font-size: 12px;
  color: #6B7280;
  display: block;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
  display: block;
  text-align: center;
}

.chatbot-select-indicator {
  position: absolute;
  top: 16px;
  right: 16px;
  color: #1EA355;
}
</style>

<style scoped>
/* Notification de paiement */
.payment-notification {
  margin: 16px 0;
  width: 100%;
  border-radius: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.payment-notification-content {
  padding: 16px;
}

.payment-notification-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.payment-notification-header svg {
  color: #1EA355;
  margin-right: 12px;
  flex-shrink: 0;
}

.payment-notification-header span {
  font-size: 16px;
  font-weight: 600;
  color: #1A1D1F;
  flex-grow: 1;
}

.close-payment-notice {
  background: none;
  border: none;
  color: #6F767E;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-payment-notice:hover {
  background-color: #f1f3f5;
  color: #343a40;
}

.payment-notification-body {
  font-size: 14px;
  color: #495057;
  line-height: 1.5;
  max-height: 100px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.payment-notification-body.expanded {
  max-height: 1000px;
}

.payment-notification-body p {
  margin-bottom: 12px;
}

.payment-help-link {
  color: #1EA355;
  text-decoration: none;
  word-break: break-all;
  display: inline-block;
  margin-bottom: 12px;
}

.payment-help-link:hover {
  text-decoration: underline;
}

.payment-more-details {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.payment-more-details ol {
  padding-left: 20px;
  margin-bottom: 12px;
}

.payment-more-details li {
  margin-bottom: 8px;
}

.voir-plus-btn {
  background: none;
  border: none;
  color: #1EA355;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  margin-top: 8px;
}

.voir-plus-btn:hover {
  text-decoration: underline;
}

.voir-plus-btn svg {
  margin-left: 6px;
  transition: transform 0.2s ease;
}

.voir-plus-btn svg.rotated {
  transform: rotate(180deg);
}

.clickable-text {
  cursor: pointer;
  position: relative;
  display: inline-block;
  transition: all 0.2s ease;
}

.clickable-text:hover {
  color: #1EA355 !important;
  text-decoration: underline;
}

.clickable-text:active {
  transform: scale(0.98);
}

.bot-id {
  font-size: 13px;
  color: #6F767E;
  margin: 2px 0;
  font-family: monospace;
  background: #F3F4F6;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  font-weight: 500;
}

.bot-id:hover {
  background: #E5E7EB;
}
</style> 